<h1 mat-dialog-title>{{'event.event_detail' | translate}}</h1>
<div mat-dialog-content>
  <form [formGroup]="form" class="form">
    <div>
      <mat-form-field class="form-fields width-50">
        <input matInput placeholder="{{'event.title' | translate}}" formControlName="title" type="text" required>
        @if (formErrors.title.required) {
          <mat-error>
            {{'required' | translate}}
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="form-fields width-25">
        <mat-select placeholder="{{'event.event_type' | translate}}" formControlName="eventTypeId" required (selectionChange)="changeEventLevel($event)">

          @if (type) {
            <mat-select-trigger>
              <mat-icon style="vertical-align: middle;"  [ngStyle]="{'color': type.color}">brightness_1</mat-icon>&nbsp;{{type.name}}
            </mat-select-trigger>
          }
          @for (evType of data.eventTypes; track evType) {
            <mat-option [value]="evType.id">
              <mat-icon [ngStyle]="{'color': evType.color}">brightness_1</mat-icon>
              {{evType.name}}
            </mat-option>
          }
        </mat-select>
        @if (f.eventTypeId.invalid) {
          <mat-error>
            {{'required' | translate}}
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="form-fields width-25">
        <mat-select placeholder="{{'event.responsible' | translate}}" formControlName="userId" required>
          @for (us of data.users; track us) {
            <mat-option [value]="us.id">
              {{us.firstName + ' ' + us.lastName}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="form-fields width-50">
        <textarea [cdkTextareaAutosize]="true" matInput placeholder="{{'event.description' | translate}}"
        formControlName="description" type="text" required></textarea>
        @if (formErrors.description.required) {
          <mat-error>
            {{'required' | translate}}
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="form-fields width-50">
        <textarea [cdkTextareaAutosize]="true" matInput placeholder="{{'event.internal_description' | translate}}"
        formControlName="internalDescription" type="text"></textarea>
      </mat-form-field>
      <mat-form-field class="form-fields width-33">
        <input matInput placeholder="{{'event.max_participants' | translate}}" formControlName="maxParticipants" type="number">
      </mat-form-field>
      <mat-form-field class="form-fields width-33">
        <input matInput placeholder="{{'event.min_participants' | translate}}" formControlName="minParticipants" type="number">
      </mat-form-field>
      <mat-form-field class="form-fields width-33">
        <input matInput placeholder="{{'event.credits' | translate}}" formControlName="credits" type="number">
      </mat-form-field>
      <mat-form-field class="form-fields width-33">
        <input matInput [matDatepicker]="picker" placeholder="{{'event.dates' | translate}}" formControlName="dates" >
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="form-fields width-33">
        <input matInput [matDatepicker]="picker1" placeholder="{{'event.date_visible_from' | translate}}" formControlName="dateVisibleFrom" >
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="form-fields width-33">
        <input matInput [matDatepicker]="picker2" placeholder="{{'event.endOfReservation' | translate}}" formControlName="endOfReservation" >
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="form-fields width-50">
        <mat-select placeholder="{{'event.target_group' | translate}}" formControlName="targetGroup" multiple>
          @for (tg of data.targetGroups; track tg) {
            <mat-option [value]="tg.id">
              {{tg.ageMask}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-checkbox class="form-fields width-50"  formControlName="reservationPossible">{{'event.reservation_possible' | translate}}</mat-checkbox>

    </div>
  </form>

</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick('close')">Cancel</button>
  <button mat-button  (click)="onNoClick('change')" cdkFocusInitial>Change</button>
</div>
